/* eslint-disable react-hooks/exhaustive-deps */
import './Shift.css';
import React from 'react';
import WorkersTable from './subcomponents/WorkersTable';
import ShiftDetailsTable from './subcomponents/ShiftDetails';
import TimeTable from './subcomponents/TimeTable';
import InfoTable from './subcomponents/InfoTable';
import NotesTable from './subcomponents/NotesTable';

type Props = {
    gridData: any
    colIndex: number
    rowIndex: number
    day: any
    readMode?: any
}

const Shift = ({gridData, colIndex, rowIndex, day, readMode}: Props) => {
    const cellKey = `${colIndex}-${rowIndex}`;
    const shift = gridData[cellKey];

    return (
        <div key={shift.id}>
            <ShiftDetailsTable shift={shift} />
            <TimeTable shift={shift} />
            <WorkersTable shift={shift} readMode={readMode} />
            <InfoTable shift={shift} />
            <NotesTable shift={shift} />
        </div>
    );
};

export default Shift;
